<div class="selectors-container">
    <div
        class="selectors-row"
        [style.padding]="hasRowPadding ? '0px 18px' : '0px'"
        [style.width]="hasRowPadding ? 'calc(100% - 36px)' : '100%'">
        <div class="selector-wrapper">
            <div>{{ 'sensor-cable-tag.filter.fcu' | translate }}</div>
            <div
                class="selector"
                data-cy="ops-settings-console-settings-fcu-number-dropdown-field"
                (click)="openFcuSelector($event)"
                #fcuSelElement>
                <ng-container
                    *ngTemplateOutlet="
                        selectorTemplate;
                        context: {
                            displayValue: !selectedFcuNum
                                ? ('sensor-cable-tag.filter.select' | translate)
                                : ('sensor-cable-tag.selected.fcu' | translate: { num: selectedFcuNum }),
                            isOpen: isFcuSelectorOpen,
                            options: getSelectorOptions(fcuSelector),
                            onSelect: optionSelected.bind(this, fcuSelector),
                            formatOption: formatFcu.bind(this),
                        }
                    " />
            </div>
        </div>

        <div class="selector-wrapper" [class.disabledSelector]="!selectedFcuNum">
            <div>{{ 'sensor-cable-tag.filter.fu' | translate }}</div>
            <div
                class="selector"
                data-cy="ops-settings-console-settings-fu-number-dropdown-field"
                (click)="selectedFcuNum && openFuSelector($event)"
                #fuSelElement>
                <ng-container
                    *ngTemplateOutlet="
                        selectorTemplate;
                        context: {
                            displayValue:
                                selectedFuNum === null
                                    ? getNoSelectionText()
                                    : !selectedFuNum
                                      ? ('sensor-cable-tag.filter.select' | translate)
                                      : ('sensor-cable-tag.selected.fu' | translate: { num: selectedFuNum }),
                            options: getSelectorOptions(fuSelector),
                            isOpen: isFuSelectorOpen,
                            onSelect: optionSelected.bind(this, fuSelector),
                            formatOption: formatFu.bind(this),
                        }
                    " />
            </div>
        </div>
    </div>
    <div
        class="selectors-row"
        [style.padding]="hasRowPadding ? '0px 18px' : '0px'"
        [style.width]="hasRowPadding ? 'calc(100% - 36px)' : '100%'">
        <div
            class="selector-wrapper"
            [class.disabledSelector]="selectedFuNum === undefined || getSelectorOptions(slotSelector).length === 0">
            <div>{{ 'sensor-cable-tag.filter.slot' | translate }}</div>
            <div
                class="selector"
                data-cy="ops-settings-console-settings-slot-number-dropdown-field"
                (click)="selectedFuNum !== undefined && openSlotSelector($event)"
                #slotSelElement>
                <ng-container
                    *ngTemplateOutlet="
                        selectorTemplate;
                        context: {
                            displayValue: !selectedSlotNum
                                ? ('sensor-cable-tag.filter.select' | translate)
                                : paddNumber(selectedSlotNum),
                            isOpen: isSlotSelectorOpen,
                            options: getSelectorOptions(slotSelector),
                            onSelect: optionSelected.bind(this, slotSelector),
                            formatOption: paddNumber.bind(this),
                        }
                    " />
            </div>
        </div>

        <div class="selector-wrapper" [class.disabledSelector]="!getSlotTerminals()">
            <div>{{ 'sensor-cable-tag.filter.terminal' | translate }}</div>
            <div
                class="selector"
                data-cy="ops-settings-console-settings-terminal-dropdown-field"
                (click)="getSlotTerminals() && openTerminalSelector($event)"
                #terminalSelElement>
                <ng-container
                    *ngTemplateOutlet="
                        selectorTemplate;
                        context: {
                            displayValue: !selectedTerminal
                                ? ('sensor-cable-tag.filter.select' | translate)
                                : paddNumber(selectedTerminal),
                            isOpen: isTerminalSelectorOpen,
                            options: getSelectorOptions(terminalSelector),
                            onSelect: optionSelected.bind(this, terminalSelector),
                            formatOption: paddNumber.bind(this),
                        }
                    " />
            </div>
        </div>
    </div>
</div>

<ng-template
    #selectorTemplate
    let-displayValue="displayValue"
    let-isOpen="isOpen"
    let-options="options"
    let-onSelect="onSelect"
    let-formatOption="formatOption">
    <div>{{ displayValue }}</div>
    <mat-icon class="arrow" svgIcon="dropdown-arrow" />
    <ng-container *ngIf="isOpen">
        <div class="options-wrapper" #selectorElement [style.top]="optionsTop" [style.left]="optionsLeft">
            <div
                *ngFor="let option of options"
                class="selector-option"
                data-cy="ops-settings-console-settings-dropdown-option"
                (click)="onSelect(option)">
                {{ formatOption(option) }}
            </div>
        </div>
    </ng-container>
</ng-template>
